import { Grid } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import React, { FunctionComponent, useState } from 'react'

import AlertLoading from '../../../../base/components/Alert/AlertLoading'
import SimpleCard from '../../../../base/components/Template/Cards/SimpleCard'
import { swalException, swalLoading } from '../../../../utils/swal'
import { MonedaProps } from '../../../moneda/interfaces'
import MonedaPrimariaRegistroDialog from '../../../moneda/view/upsert/MonedaPrimariaRegistroDialog'
import { apiArticuloMoneda } from '../../api/apiArticuloMoneda'
import { apiArticuloMonedaPrimariaRegistro } from '../../api/apiRegistroMonedaPrimaria'
import ArticuloMonedaCard from '../../components/ArticuloMonedaCard'

interface OwnProps {}

type Props = OwnProps

/**
 * Gestion o paginba principal para gestionar los articulo Moneda
 * @constructor
 */
const ArticuloMonedaLocal: FunctionComponent<Props> = () => {
  const [openRegistroMoneda, setOpenRegistroMoneda] = useState(false)

  const {
    data: articuloMoneda,
    isLoading: articuloMonedaLoading,
    refetch,
  } = useQuery({
    queryKey: ['articuloMoneda'],
    queryFn: async () => {
      return apiArticuloMoneda()
    },
  })

  /**
   * Registramos la moneda
   * @param data
   */
  const registrarMonedaPrincipal = async (data: MonedaProps) => {
    swalLoading()
    const resp = await apiArticuloMonedaPrimariaRegistro(data.codigo).catch((e: any) => {
      swalException(e)
    })
    if (resp) {
      setOpenRegistroMoneda(false)
      await refetch()
      window.location.reload()
    }
  }

  if (articuloMonedaLoading)
    return (
      <>
        <AlertLoading mensaje={'Cargando Moneda Primaria'} />
      </>
    )

  return (
    <>
      <SimpleCard title={'Moneda Local de sistema'}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <ArticuloMonedaCard
              moneda={articuloMoneda?.monedaPrimaria || null}
              monedaLocal={articuloMoneda?.monedaPrimaria || null}
              subTitle={'Moneda Primaria'}
              editable={false}
              onRegistro={(resp?: boolean) => {
                if (resp) {
                  setOpenRegistroMoneda(true)
                }
              }}
              onEliminar={(resp?: MonedaProps) => {
                if (resp) {
                  console.log(resp)
                }
              }}
              onActualizar={(resp?: MonedaProps) => {
                if (resp) {
                  console.log(resp)
                }
              }}
            />
          </Grid>
        </Grid>
      </SimpleCard>
      <MonedaPrimariaRegistroDialog
        id={'MonedaLocalRegistro'}
        keepMounted={false}
        open={openRegistroMoneda}
        onClose={async (resp?: MonedaProps) => {
          if (resp) {
            await registrarMonedaPrincipal(resp)
          } else setOpenRegistroMoneda(false)
        }}
      />
    </>
  )
}

export default ArticuloMonedaLocal
